export default "__VITE_ASSET__6fc0fd92__"